import react from "react";
import { FaPhone, FaEnvelope, FaWhatsapp } from "react-icons/fa";

const sublink = [
  {
    page: "Computer and Accessories",
    url: "#",
    cName: "nav-text",
  },
  {
    page: "Phone and Tablets",
    url: "#",
    cName: "nav-text",
  },
  {
    page: "Electronics",
    url: "#",
    cName: "nav-text",
  },
  {
    page: "Kundum Fashion",
    url: "#",
    cName: "nav-text",
  },
  {
    page: "Home and Kitchen",
    url: "#",
    cName: "nav-text",
  },
  {
    page: "Baby, Kids and Toys",
    url: "#",
    cName: "nav-text",
  },
];

export default sublink;

export const image = [
  {
    id: 1,
    url: "https://www-konga-com-res.cloudinary.com/image/upload/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/v1676375692/contentservice/ValentineIntel.jpg_Bym5Ugt6i.jpg",
  },
  {
    id: 2,
    url: "https://www-konga-com-res.cloudinary.com/image/upload/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/v1675675456/contentservice/s23.jpg_HkDHDS0hs.jpg",
  },
  {
    id: 3,
    url: "https://www-konga-com-res.cloudinary.com/image/upload/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/v1676972108/contentservice/Phone.jpg_By78lfGRo.jpg",
  },
  {
    id: 4,
    url: "https://www-konga-com-res.cloudinary.com/image/upload/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/v1675953562/contentservice/Flash.jpg_H1WoHKG6i.jpg",
  },
];

export const heroImage = [
{
id: 40,
price: 80,
title:"Warrior S 3x3 Stickerless Speed Cube Puzzle.",
description: "description",
category:"bags",
image: "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/U/E/170511_1633601231.jpg"
},
{
id: 41,
price: 50,
title: 'Baby Bag With Bed.',
description: "description",
category:"bags",
image: "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/Z/E/123911_1641500981.jpg",
},
{
id: 42,
price: 100,
title: "Newborn Gift Pack 10 In 1 Unisex - Sleepsuits + 12set Free Combs." ,
description: "description",
category:"kids",
image: "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/L/B/184063_1637244286.jpg",
},
{
id: 43,
price: 103,
title: "Baby Bed." ,
description: "description",
category:"kids",
image: "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/a/Baby-Bed-8073997.jpg",
}
];

export const heroCategories = [
  {
    linkTittle: "Kundum Blog",
    link: "#",
  },
  {
    linkTittle: "Pay Bills",
    link: "#",
  },
  {
    linkTittle: "Free Delivery",
    link: "#",
  },
  {
    linkTittle: "Offline Store",
    link: "#",
  },
  {
    linkTittle: "Brand Stores",
    link: "#",
  },
  {
    linkTittle: "Book Flights",
    link: "#",
  },
];

export const footerSocial = [
  {
    title: "PHONE SUPPORT",
    redirect: "#",
    label: ["07034205338"],
    logo: <FaPhone />,
  },
  {
    title: "WHATSAPP",
    redirect: "#",
    label: ["07034205338"],
    logo: <FaWhatsapp />,
  },
  {
    title: "EMAIL SUPPORT",
    redirect: "#",
    label: ["help@kundum.com"],
    logo: <FaEnvelope />,
  },
];

export const other = [
  {
    title: "ABOUT KUNDUM",
    list: [
      "Contact Us",
      "About Us",
      "Careers",
      "Our Blog",
      "Forum",
      "Terms & Conditions",
    ],
    links: ["#", "#", "#", "#", "#", "#"],
  },
  {
    title: "BUYING ON KUNDUM",
    list: ["Buyer Safety Centre", "FAQs", "Delivery", "Kundum Return Policy"],
    links: ["#", "#", "#", "#"],
  },
  {
    title: "MAKE MONEY WITH KUNDUM",
    list: [
      "Sell on kundum",
      "Become a Sales Consultant",
      "Become a Logistics Service Partner",
    ],
    links: ["#", "#", "#"],
  },
];

// id: id,
// price: price,
// title: title,
// description: description,
// category: category,
// image: image,
export const todaysdeal = [
  {
    id: 21,
    discount: 10,
    category: "phone",
    price: 80,
    initialPrice: 80,
    image:"https://th.bing.com/th/id/OIP.duolKlzf0U95hepBAfd0mwHaFn?pid=ImgDet&w=151&h=114&c=7",
    title: "Samsung Galaxy S23 UltraSamsung Galaxy S23 Ultra",
    description: "Release date: February 2023Weight: 234gDimensions: 163.4 x 78.1 x 8.9mmOS: Android 13 w/ One UI 5.1Screen size: 6.8-inchResolution: 1440 x 3088CPU: Snapdragon 8 Gen 2 Mobile Platform for GalaxyRAM: 8GB / 12GBStorage: 256GB / 512GB / 1TBBattery: 5,000mAhRear camera: 200MP (wide) + 10MP (telephoto, 3x optical) + 10MP (telephoto, 10x optical) + 12MP (ultrawide, 120-degree)Front camera: 12MP",
  },
  {
    id: 22,
    discount: 30,
    category: "phone",
    price: 150,
    initialPrice: 150,
    image:"https://th.bing.com/th/id/OIP.C0AXagG9019pUJ-YhUYyNwHaEo?pid=ImgDet&w=151&h=94&c=7",
    title: "Google Pixel 6a",
    description: "Release date: May 2022Weight: 178gDimensions: 152.2 x 71.8 x 8.9 mmOS: Android 12Screen size: 6.1-inchResolution: 1080 x 2400CPU: Google TensorRAM: 6GBStorage: 128GBBattery: 4,410mAhRear camera: 12.2+12MPFront camera: 8MP",
  },
  {
    id: 23,
    discount: 10,
    category: "phone",
    price: 60,
    initialPrice: 60,
    image:"https://www.mobiledokan.co/wp-content/uploads/2019/09/TECNO-Spark-3-Pro-Black.jpg",
    title: "TECNO Spark 3 Pro",
    description: "TECNO Spark 3 Pro smartphone comes with 6.2 inches, 96.7 cm2 (~83.0% screen-to-body ratio), IPS LCD capacitive touchscreen, 16M colors display and performing Quad-core Quad-core 2.0 GHz Cortex-A53, Spark 3 Pro running Mediatek MT6761 Helio A22 (12 nm) processor. It has 2 GB of RAM and 32 GB internal storage, which can expend 64 GB external storage. This stylish device has a 13 MP, 2 MP in the back and an 8 MP camera on the front side. It was powered by a standard 3500 mAh Li-ion battery.",
  },
  {
    id: 24,
    discount: 50,
    category: "phone",
    price: 80,
    initialPrice: 80,
    image:"https://priceinsouthafrica.com/wp-content/uploads/2020/10/Tecno-Camon-16-SE-Price-in-South-Africa-767x730.jpg",
    title: "Tecno Spark 7 Pro",
    description: "The Tecno Spark 7 Pro is now available in two variants (64/128GB/6GBGB RAM). Now, Tecno Spark 7 Pro’s Price is 13,490 Bangladesh. Spark 7 Pro has a 5000mAh battery with no fast charging. This device is running with Android 11 and powered by the Mediatek Helio G80 (12 nm) chipset.",
  },
  {
    id: 25,
    discount: 40,
    category: "phone",
    price: 150,
    initialPrice: 150,
    image:"https://i5.walmartimages.com/asr/3f1e2c45-dd5a-4816-b17e-f74018c89983.01467d2755c4140861bba75c78e9d3c6.jpeg",
    title: "Samsung Galaxy A51 5G Black, Unlocked",
    description: "Samsung Galaxy A51 5G smartphone/android phone comes with 6.5 inches, 102.0 cm2 (~87.2% screen-to-body ratio), Super AMOLED capacitive touchscreen, 16M colors display and resolution 1080 x 2400 pixels, 20:9 ratio (~405 ppi density). Galaxy A51 5G performing Octa-core (2×2.2 GHz Cortex-A77 & 6×1.8 GHz Cortex A55), Exynos 980 (8 nm) processor. It has 6/8 GB of RAM and 128/256 GB internal storage, which can be expanded microSDXC (dedicated slot) external storage. This stylish device has 48 MP, 12 MP, 5 MP, 5 MP in the back and a 32 MP camera on the front side. It was powered by a standard unknown 4500 mAh Li-po battery.",
  },
  {
    id: 26,
    discount: 10,
    category: "phone",
    price: 500,
    initialPrice: 500,
    image: "https://www.mobiledokan.co/wp-content/uploads/2021/09/Apple-iPhone-14-Midnight.jpg",
    title: "Apple iPhone 14",
    description: "The Apple iPhone 14 is now available in three variants (128GB/6GB, 256GB/6GB, 512GB/6GB). Now, iPhone 14 Price is 146999 in Bangladesh. iPhone 14 has a 3279mAh battery with super-fast charging. This device is running with iOS 15 and powered by the Apple A16 Bionic chipset.",
  },
  {
    id: 27,
    discount: 10,
    category: "kids",
    price: 100,
    initialPrice: 100,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/X/U/2799_1622669924.jpg",
    title: "Advanced Anticolic Newborn Bottle Starter Set.",
    description: "best product",
  },
  {
    id: 28,
    discount: 20,
    category: "kids",
    price: 100,
    initialPrice: 100,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/O/N/123911_1652814139.jpg",
    title: "Pvc/steel Kids Wardrobe.",
    description: "best product",
  },
  {
    id: 29,
    discount: 30,
    category: "kids",
    price: 100,
    initialPrice: 100,
    image: "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/Q/Z/157787_1639650938.jpg",
    title: "Bicycles Size 20 For Kids.",
    description: "best product",
  },
  {
    id: 30,
    discount: 50,
    category: "kids",
    price: 0,
    initialPrice: 100,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/Z/H/113850_1594509385.jpg",
    title: "Mini Educational Learn Pad For Kids - White.",
    description: "best product",
  },
  {
    id: 31,
    discount: 40,
    category: "kids",
    price: 120,
    initialPrice: 120,
    image:"https://th.bing.com/th/id/R.57f7417e191bf38385f2ae72b3df647b?rik=3kJirStidmzJjA&riu=http%3a%2f%2fwww.kidswear-magazine.com%2fwp-content%2fuploads%2f2017%2f01%2fkw-Wawa-ss17-5-540x809.jpg&ehk=DznvPogt9BrzTzy%2bsp7wvJSAxGeP1XADq6JdmxSOEcg%3d&risl=&pid=ImgRaw&r=0",
    title: "Kid’s Wear",
    description: "best product",
  },
  {
    id: 32,
    discount: 40,
    category: "kids",
    price: 120,
    initialPrice: 120,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/O/W/121332_1577995444.jpg",
    title: "Kendamil Follow On Milk - Stage 2 - 900g.",
    description: "best product",
  },
  {
    id: 33,
    discount: 40,
    category: "kids",
    price: 120,
    initialPrice: 120,
    image:"https://static.turbosquid.com/Preview/2015/12/25__04_06_32/3.png11e3f818-e203-49b3-adf0-5a3d20be8addZoom.jpg",
    title: "fashion clothing baby girls",
    description: "best product",
  },
  {
    id: 34,
    discount: 40,
    category: "computer",
    price: 120,
    initialPrice: 120,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/T/F/209757_1672151655.jpg",
    title: "A105 Max Tablet PC 5G - 10.1&quot; - 256GB ROM - 6GB RAM - Zoom Support - 6000mAh + Keyboard - Gold",
    description: "best product",
  },

  {
    id: 35,
    discount: 10,
    category: "computer",
    price: 120,
    initialPrice: 120,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/I/X/210744_1670513046.jpg",
    title: "Children Tablets - 2G RAM - 16GB ROM - Wifi - Pink Pouch.",
    description: "best product",
  },
  {
    id: 36,
    discount: 50,
    category: "computer",
    price: 100,
    initialPrice: 100,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/H/M/_1659000856.png",
    title: "Tablet + 1 year subscription- 8&quot; - 32GB ROM - 2GB RAM - Single Sim - Black.",
    description: "best product",
  },
  {
    id: 37,
    discount: 10,
    category: "computer",
    price: 200,
    initialPrice: 200,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/E/V/183051_1665498766.jpg",
    title: "A105 Max Tablet Pc 5g - 10.1&quot; - 256GB ROM- 6GB RAM - Zoom Support - 6000mah + Keyboard.",
    description: "best product",
  },
  {
    id: 38,
    discount: 10,
    category: "computer",
    price: 250,
    initialPrice: 250,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/Y/S/_1659000901.png",
    title: "uLesson Tablet + 3 Years uLesson Subscription- 8&quot; - 32gb Rom - 2gb Ram - Single Sim - Black.",
    description: "best product",
  },
  {
    id: 39,
    discount: 10,
    category: "computer",
    price: 300,
    initialPrice: 300,
    image:"https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/K/i/Kids-Educational-iPad-For-Learning-Blue-6497501_1.jpg",
    title: "Kids Educational iPad For Learning | Blue.",
    description: "best product",
  },
];


